<template>
	<div>
		<section class="is-simple" v-if="!altVersion">
			<div>
				<h2>Come funziona la Spesa Online con Quomi</h2>
				<p>Fai ordini singoli o scegli l'opzione in abbonamento e risparmi sempre sulle spese di consegna!</p>
				<div class="flex wrap is-simple-content">
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="choose-products"></p>
						<h4>1. Scegli i tuoi prodotti preferiti</h4>
						<div>Fai la tua spesa con kit ricette, <br>cassette di frutta e verdura e <br>tanti prodotti freschi e di qualità</div>
					</div>
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="from-producers"></p>
						<h4>2. Riceviamo i prodotti dai nostri produttori</h4>
						<div>Riceviamo tutti i prodotti freschi <br>dai nostri produttori selezionati<br>e prepariamo la tua spesa </div>
					</div>
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="deliver-orders"></p>
						<h4>3. Consegniamo la tua spesa a casa</h4>
						<div>Scegli il giorno e l'orario di consegna che preferisci<br> e ricevi la tua spesa a casa<br> o presso un punto di ritiro</div>
					</div>
				</div>
			</div>
			<div class="pa-5">
				Per saperne di più, visita la pagina <router-link :to="{name:'how-it-works'}" class="link-detail" style="color: var(--quomi-blue)">Come funziona</router-link>
			</div>
		</section>

		<section class="is-simple" v-else>
			<div>
				<h2>Come funziona la Spesa Online con Quomi</h2>
				<p>Fai ordini singoli o scegli l'opzione in abbonamento e risparmi sempre sulle spese di consegna!</p>
				<div class="flex wrap is-simple-content">
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="choose-recipes"></p>
						<h4>1. Scegli le tue ricette</h4>
						<div>Ogni settimana un nuovo menù per tutti i gusti. Cucina senza sprechi e divertiti con le schede ricette.</div>
					</div>
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="complete-order"></p>
						<h4>2. Completa la tua spesa</h4>
						<div>Naviga la Bottega e scopri la nostra selezione di alta qualità. Direttamente dal produttore alla tua tavola.</div>
					</div>
					<div class="col-md-4 col-sm-12 d-flex flex-column align-items-center">
						<p class="subscribe"></p>
						<h4>3. Abbonati senza vincoli</h4>
						<div>Scegli frequenza e giorno di consegna. Puoi sospenderti quando vuoi e avrai sempre la consegna gratuita!</div>
					</div>
				</div>
			</div>
			<div class="pa-5">
				Per saperne di più, visita la pagina <router-link :to="{name:'how-it-works'}" class="link-detail" style="color: var(--quomi-blue)">Come funziona</router-link>
			</div>
		</section>
	</div>
</template>

<script type="text/javascript">
	export default {
		props: {
			altVersion: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style scoped>
section {
	text-align: center;
}

h2 {
	text-align: center;
}

h4 {
	font-size: 16px;
	font-weight: bold;
}

.is-simple-content {
	padding-top: 25px;
}

.is-simple-img {
	max-height: 10rem;
}

.is-simple-img-round {
	max-height: 200px;
}

.choose-products,
.from-producers,
.deliver-orders,
.choose-recipes,
.complete-order,
.subscribe {
	min-width: 300px;
	min-height: 200px;
	background-repeat: no-repeat;
	background-size:cover;
}

.choose-products {
	background-image: url("https://api.quomi.it/oldimg/Comefunziona1.png");
}
.from-producers {
	background-image: url("https://api.quomi.it/oldimg/Comefunziona2.png");
	background-position: center;
}
.deliver-orders {
	background-image: url("https://api.quomi.it/oldimg/Comefunziona3.png");
	background-position: center;
}

.choose-recipes {
	background-image: url("https://api.quomi.it/oldimg/Quomi-kit-ricette-a-casa.webp");
}
.complete-order {
	background-image: url("https://api.quomi.it/oldimg/Homepage2.png");
	background-position: center;
}
.subscribe {
	background-image: url("https://api.quomi.it/oldimg/Homepage3_v2.png");
	background-position: center;
}

@media only screen and (max-width: 768px) {
	.is-simple-content .col-sm-12 + .col-sm-12{
		padding-top: 30px;

	}
}

</style>